<template>
  <div class="overflow-ss flex items-center justify-center inside-card">
    <div v-if="hasNoAccount" class="mx-auto max-w-screen-xl px-4 py-12">
      <img style="margin-bottom: 100px" src="@/assets/img/card_empty.svg" />
      <p style="margin-bottom: 40px">هنوز هیج حسابی متصل نکرده‌اید</p>
      <button class="m-btn" @click="createAccountHandler">
        اتصال حساب جدید
      </button>
    </div>
    <account-card
      v-else
      :accountList="accountList"
      @creat="createAccountHandler"
    >
    </account-card>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import accountCard from "./account.vue";
export default {
  components: {
    accountCard,
  },
  data() {
    return {
      title: null,
      accountList: [],
      hasNoAccount: false,
    };
  },
  beforeMount() {
    this.title = this.$route.meta.prtitle;
    this.getAccountLsit();
  },
  methods: {
    getAccountLsit() {
      this.$store.dispatch("businessaccount/getList").then((rsp) => {
        this.accountList = rsp;
        if (this.accountList.length == 0) {
          this.hasNoAccount = true;
        }
      });
    },
  },
  setup() {
    let cardNumber = ref("");
    const router = useRouter();
    function createAccountHandler() {
      // const token = localStorage.getItem("token");
      // axios
      //   .post(
      //     "https://gamma.bfst.ir/account/",
      //     {
      //       bank: {
      //         name: "string",
      //         bank_id: "string",
      //       },
      //       bank_account_number: cardNumber.value,
      //       sheba: "string",
      //       card_number: "string",
      //       permission_ids: [1],
      //       is_default: false,
      //     },
      //     {
      //       headers: { Authorization: `Bearer ${token}` },
      //     }
      //   )
      //   .then((response) => {
      //     console.log(response);
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });

      router.push({ name: "AddBusinessAccounts" });
    }

    return {
      cardNumber,
      createAccountHandler,
    };
  },
};
</script>
<style scoped>
.overflow-ss {
  overflow: scroll;
}
</style>
